import React from 'react';
import { Icon } from 'venn-ui-kit';
import { cn } from '@/lib/utils';

type CashIconProps = {
  isNegativeAssets: boolean;
  disabled?: boolean;
};

export const CASH_ICON_POSITIVE_CLASS = 'cash-icon-positive';
export const CASH_ICON_NEGATIVE_CLASS = 'cash-icon-negative';

const getColorClassName = ({ isNegativeAssets, disabled }: CashIconProps) => {
  if (disabled) {
    return 'text-venn-grey';
  }
  return isNegativeAssets ? 'text-venn-error' : 'text-venn-green';
};

const getMarkerClassName = ({ isNegativeAssets }: Pick<CashIconProps, 'isNegativeAssets'>) => {
  return isNegativeAssets ? CASH_ICON_NEGATIVE_CLASS : CASH_ICON_POSITIVE_CLASS;
};

const getClassNames = ({ isNegativeAssets, disabled }: CashIconProps) => {
  return cn(getColorClassName({ isNegativeAssets, disabled }), getMarkerClassName({ isNegativeAssets }));
};

export const CashIcon = ({ isNegativeAssets, disabled = false }: CashIconProps) => {
  return (
    <Icon
      type="square-dollar"
      iconLabel={isNegativeAssets ? 'Cash Borrowing icon' : 'Cash Holding icon'}
      className={getClassNames({ isNegativeAssets, disabled })}
    />
  );
};
